const basicSettings = (r) =>
  require.ensure(
    [],
    () => r(require('../views/setting/BasicSettings.vue')),
    'basicSettings'
  )
const holidayArrange = (r) =>
  require.ensure(
    [],
    () => r(require('../views/setting/holidayArrange.vue')),
    'holidayArrange'
  )
const dutyTeacher = (r) =>
  require.ensure(
    [],
    () => r(require('../views/setting/DutyTeacher.vue')),
    'DutyTeacher'
  )



    //设置
export default[
  {
    name: 'basicSettings',
    path: '/basicSettings',
    component: basicSettings,
    meta: { title: '基础信息' },
  },
  {
    name: 'holidayArrange',
    path: '/holidayArrange',
    component: holidayArrange,
    meta: { title: '节假日安排' },
  },
  {
    name: 'dutyTeacher',
    path: '/dutyTeacher',
    component: dutyTeacher,
    meta: { title: '值班老师' },
  },
]